import * as ACTION_TYPES from 'actions/actionTypes';
import { get } from 'lodash';

// if no wonoloers are selected close preferred should be false
const getIsClosedPreferred = (wonoloers, isClosedPreferred) => !!(wonoloers.length && isClosedPreferred);

export const preferredModalReducer = (state = { isClosedPreferred: false }, action) => {
  switch (action.type) {
    case ACTION_TYPES.PREFERRED_MODAL_SELECT_WONOLOER: {
      const { payload: wonoloer } = action;
      const { [wonoloer.id]: removedWonoloer, isClosedPreferred, ...rest } = state;
      const wonoloers = Object.keys(rest);
      if (removedWonoloer) {
        return { ...rest, isClosedPreferred: getIsClosedPreferred(wonoloers, isClosedPreferred) };
      }
      return { ...state, [wonoloer.id]: wonoloer };
    }
    case ACTION_TYPES.PREFERRED_MODAL_SELECT_TEAM: {
      const { payload: team } = action;

      const nextState = team.teamMembers.reduce((acc, teamMember) => {
        const { id } = teamMember;
        return { ...acc, [id]: teamMember };
      }, state);

      return nextState;
    }
    case ACTION_TYPES.PREFERRED_MODAL_HYDRATE: {
      const preferredWonoloers = get(action, 'payload.preferredWonoloers', []);
      const isClosedPreferred = getIsClosedPreferred(preferredWonoloers, get(action, 'payload.isClosedPreferred', false));
      return preferredWonoloers.reduce((acc, teamMember) => {
        const { id } = teamMember;
        return { ...acc, [id]: teamMember };
      }, { isClosedPreferred });
    }
    case ACTION_TYPES.PREFERRED_MODAL_UPDATE_IS_CLOSED_PREFERRED: {
      const { payload: isClosedPreferred } = action;
      return { ...state, isClosedPreferred };
    }
    default:
      return { ...state };
  }
};
